import { Component, ComponentFactoryResolver, ElementRef, OnInit, QueryList, ViewChild, ViewChildren, ViewContainerRef } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { GeneralService } from 'src/app/core/services/general/general.service';
import { UntypedFormBuilder } from '@angular/forms';
import { FormasDeContactoDosComponent } from 'src/app/shared/widgets/formas-de-contacto/formas-de-contacto-dos.component';
import { BuscadorCursosTematicoComponent } from 'src/app/shared/components/buscador-cursos-tematico/buscador-cursos-tematico.component';
import { PortadaComponent } from 'src/app/shared/widgets/portada/portada.component';
import { LoaderService } from 'src/app/core/load/load.service';
import { lastValueFrom, take } from 'rxjs';


@Component({
  selector: 'app-detalle-curso',
  templateUrl: './detalle-curso.component.html',
  styleUrls: ['./detalle-curso.component.scss']
})
export class DetalleCursoComponent implements OnInit {
  @ViewChildren('dynamicContainer', { read: ViewContainerRef }) containers!: QueryList<ViewContainerRef>;
  @ViewChildren('lazyWrapper', { read: ElementRef }) wrappers!: QueryList<ElementRef>;
  pages: any[] = [];
  nextIndex = 0;


  id: any
  area = {};
  areaUrl = "";
  sede: any;
  refBuscador: any

  titulo: any
  subitulo: any
  itemName: string;
  tieneTyS: boolean = true

  areaRecomendadaPending: any
  language = ''



  constructor(private aRouter: ActivatedRoute, private services: GeneralService,
    public router: Router, private form: UntypedFormBuilder,
    private componentFactoryResolver: ComponentFactoryResolver,
    private loader: LoaderService,) {
    this.loader.setLoading(true);

    this.aRouter.params.forEach((params: Params) => {
      this.language = (params['language']) ? params['language'] : 'es';
    });
    const currentUrl = this.aRouter.snapshot.url.join('/');
    this.id = currentUrl.replace(this.language + '/', '');


  }
  ngAfterViewInit(): void {

    this.services.getSimplepage(this.id, this.language).subscribe(res => {
      if (res.data[0]) {
        this.area = res.data[0]?.area_tematica;
        this.sede = res.data[0].region;

      }

      this.pages = Object.keys(res.data[0].pages)
        .filter(key => !isNaN(Number(key)))
        .map(key => res.data[0].pages[key][0]);

      let pagePending = this.pages.find(p => p.entityType == "AreaRecomendada")
      if (pagePending) {
        this.services.getEntities(pagePending?.route + '&locale=' + this.language).subscribe(data => {
          this.areaRecomendadaPending = data.data;
        })
      }

      this.pages = this.pages.filter(p => p.entityType !== "AreaRecomendada");
      // 🔹 Pre-cargar entidades
      this.preloadEntities().then(() => {
        // 🔹 Cuando todas estén listas, iniciar lazy load
        setTimeout(() => this.initSequentialLazyLoad(), 0);
      });
    })
  }
  preloadedData: any;
   preloadEntities(): Promise<void> {
      const requests = this.pages.map(page => {
        const url = page.route + '&locale=' + this.language;
  
        return lastValueFrom(
          this.services.getEntities(url).pipe(take(1))
        ).catch(error => {
          console.error(`Error cargando la ruta: ${url}`, error);
          return null;
        });
      });
  
      return Promise.all(requests).then(results => {
        this.preloadedData = results;
      }).catch(err => {
        console.error("Error crítico en Promise.all:", err);
      });
    }

  initSequentialLazyLoad() {
    // Asegurarse de que nextIndex arranca en 0
    this.nextIndex = 0;

    const wrappersArray = this.wrappers.toArray();

    const loadNext = (index: number) => {
      if (index >= this.pages.length) {
        this.loader.setLoading(false);
        return
      };

      const wrapper = wrappersArray[index];
      if (!wrapper) return;

      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Cargar datos
            const page = this.pages[index];
            const data = this.preloadedData[index];
            this.newComponent(index, page.entityType, data);

            // Fade-in al aparecer
            const currentWrapper = wrappersArray[index].nativeElement;
            currentWrapper.classList.add('loaded');
            (currentWrapper as HTMLElement).style.minHeight = "0px";


            // Avanzar al siguiente
            loadNext(index + 1);


            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0 }); // threshold 0 para disparar apenas aparece

      observer.observe(wrapper.nativeElement);
    };

    // arrancamos con el primero
    loadNext(this.nextIndex);
  }


  newComponent(index: number, type: string, info: any) {
    const container = this.containers.toArray()[index]; // obtenemos el ViewContainerRef correspondiente
    let ref: any;
    let factory;
    switch (type) {
      case "PortadaSedes": {
        // Configuración para "PortadaSedes"
        factory = this.componentFactoryResolver.resolveComponentFactory(PortadaComponent);
        ref = container.createComponent(factory);

        ref.instance.data = info.data[0];
        ref.instance.area = this.area;
        ref.instance.marginTitle = 40;
        ref.instance.heightDesk = "525px";
        ref.instance.heightMob = "370px";
        ref.instance.layerPathMob = info.data[0]?.cover?.pathMobileSuperpuesta;
        ref.instance.layerPath = info.data[0]?.cover?.pathSuperpuesta;

        break;
      }

      case "PortadaAreas":
      case "Portada": {
        factory = this.componentFactoryResolver.resolveComponentFactory(PortadaComponent);
        ref = container.createComponent(factory);
        // ref.location.nativeElement.classList.add('col-lg-' + width);
        this.titulo = info.data[0].cover.title
        this.subitulo = info.data[0].cover.subtitle
        ref.instance.area = this.area;
        ref.instance.data = info.data[0];
        ref.instance.marginTitle = 75;
        ref.instance.heightDesk = "200px";
        ref.instance.heightMob = "250px";
        ref.changeDetectorRef.detectChanges();

      }
        break;


      case 'Buscador': {

        factory = this.componentFactoryResolver.resolveComponentFactory(BuscadorCursosTematicoComponent);
        ref = container.createComponent(factory);
        ref.instance.titulo = "Educación continua";
        ref.instance.translateY = (this.area) ? 75 : 40;
        ref.instance.padding = (this.area) ? "38.6px 35px" : "30px 35.6px 30px 35.6px";
        ref.instance.paddingMob = "35px";
        ref.instance.data = info.data;
        ref.instance.area = this.area;
        ref.instance.sede = this.sede;

        ref.changeDetectorRef.detectChanges();
        this.refBuscador = ref;
        // aplicamos AreaRecomendada si estaba pendiente
        if (this.areaRecomendadaPending) {
          this.refBuscador.instance.infoAreaRecomendada = this.areaRecomendadaPending;
          this.refBuscador.changeDetectorRef.detectChanges();
          this.areaRecomendadaPending = null;
        }

      }
        break;

      case "Contacto": {
        factory = this.componentFactoryResolver.resolveComponentFactory(FormasDeContactoDosComponent);
        ref = container.createComponent(factory);
        ref.instance.data = info.data;
        ref.instance.fondo = "Fondo-web-continua.png";
        ref.instance.esCurso = true
        ref.changeDetectorRef.detectChanges();

      }
        break;
    }
  }


  ngOnInit(): void {

  }


}
